import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormTextComplexBaseComponent } from '../base-complex/form-text-complex-base.component';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShAutocompleteComponent } from '../../_core/autocomplete/autocomplete.component';
import { ShAutoFocusDirective } from '../../../../elements/directives/auto-focus/auto-focus.directive';

@Component({
    selector: 'sh-form-text-base',
    templateUrl: '../base-complex/form-text-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormTextBaseComponent)],
    standalone: true,
    imports: [ShAutocompleteComponent, ReactiveFormsModule, AsyncPipe, ShAutoFocusDirective]
})
export class ShFormTextBaseComponent extends ShFormTextComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<string>): void {
        super.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
